// import Vue from 'vue'
import Vuex from 'vuex'
import helpers from './modules/helpers';
import user from './modules/user';
import email from './modules/email';
import navbar from './modules/navbar';
import posts from './modules/posts';
import category from './modules/category';
import address from './modules/address';
import cropper_image from './modules/cropper_image';
import document from './modules/document';
import comercial from './modules/comercial';
import contribution from './modules/contribution';

// Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        helpers,
        user,
        email,
        navbar,
        posts,
        category,
        address,
        cropper_image,
        document,
        comercial,
        contribution
    }
})
